<template>
  <div>
    <el-tabs type="border-card">

        <!-- <el-tab-pane label="数据视图">
          <data-view />
      </el-tab-pane> -->

      <el-tab-pane label="数据信息">
        <data-info  :mdDatas = "mdInfo" :tabledatas="TableData" />
      </el-tab-pane>

    </el-tabs>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import DataInfo from '@/components/DataInfo'
import DataView from './DataView'

export default {
  components: { DataView, DataInfo },
  data() {
    return {
      activeName: 'DV',
      tableKey: 1,
      treedatas: [{'column_name':'请选择所要查看的数据'}],
      mdInfo: '',
    }
  },
  computed:{
    ...mapState('listdata', ['clicknode']),
  },
  watch:{
    Clickdata:{
      deep: true,
      handler(val){
        this.treedatas = val
      }
    },
    activeName(val) {
      this.$router.push(`${this.$route.path}?tab=${val}`)
    },
    clicknode:{
      deep: true,
      handler(val) {
        if (val) {
          const ppids = val.pid.split('_')[0] + '.md'
          import('@/datamd/' + ppids).then(myMoudle => { this.mdInfo = myMoudle }).catch(err => {this.mdInfo = ''});
        }
      }
    },
  },
  props: {
    TableData: {
      type: Array,
      required: true
    }
  },
  created(){
    const tab = this.$route.query.tab
    if (tab) {
      this.activeName = tab
    }
  },
}
</script>


// WEBPACK FOOTER //
// src/layout/components/DataMain/index.vue